var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1635 6C0.178 5.9535 0.1845 5.905 0.201 5.859L1.55 2.1455C1.72617 1.66365 2.04598 1.24748 2.46624 0.953207C2.8865 0.658936 3.38696 0.500743 3.9 0.5H8.1C8.61312 0.500709 9.11365 0.658947 9.53393 0.953322C9.95421 1.2477 10.274 1.66402 10.45 2.146L11.8 5.859C11.8165 5.905 11.823 5.9535 11.8375 6H0.1635ZM10 7V8C10 8.13261 9.94732 8.25979 9.85355 8.35355C9.75979 8.44732 9.63261 8.5 9.5 8.5C9.36739 8.5 9.24021 8.44732 9.14645 8.35355C9.05268 8.25979 9 8.13261 9 8V7H3V8C3 8.13261 2.94732 8.25979 2.85355 8.35355C2.75979 8.44732 2.63261 8.5 2.5 8.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8V7H0V8C0.000639188 8.48588 0.142853 8.96105 0.40925 9.36739C0.675646 9.77374 1.05468 10.0936 1.5 10.288V11C1.5 11.2652 1.60536 11.5196 1.79289 11.7071C1.98043 11.8946 2.23478 12 2.5 12C2.76522 12 3.01957 11.8946 3.20711 11.7071C3.39464 11.5196 3.5 11.2652 3.5 11V10.5H8.5V11C8.5 11.2652 8.60536 11.5196 8.79289 11.7071C8.98043 11.8946 9.23478 12 9.5 12C9.76522 12 10.0196 11.8946 10.2071 11.7071C10.3946 11.5196 10.5 11.2652 10.5 11V10.288C10.9453 10.0936 11.3244 9.77374 11.5908 9.36739C11.8571 8.96105 11.9994 8.48588 12 8V7H10Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBlack);
export default __webpack_public_path__ + "static/media/carBlack.24749245689dd4c7285c5812d63734cb.svg";
export { ForwardRef as ReactComponent };